module.exports = __webpack_public_path__ + "img/logo-onwhite.268ca49b.svg";